import React, { useState } from "react";

const FeedbackPage = () => {
  const [feedback, setFeedback] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Feedback submitted:", feedback);
    alert("Hvala za vaše mnenje!");
    setFeedback("");
  };

  return (
    <div className="container py-5">
      <h1 className="mb-4">Pošlji povratno informacijo</h1>
      <p>Vaše mnenje nam veliko pomeni! Sporočite nam, kaj bi lahko izboljšali:</p>
      <form onSubmit={handleSubmit}>
        <div className="mb-3">
          <textarea
            className="form-control"
            rows="5"
            value={feedback}
            onChange={(e) => setFeedback(e.target.value)}
            placeholder="Vaše sporočilo..."
            required
          ></textarea>
        </div>
        <button type="submit" className="btn btn-primary">
          Pošlji
        </button>
      </form>
    </div>
  );
};

export default FeedbackPage;